module.exports = __webpack_public_path__ + "img/zhuanye-yuangong.4d7be1d2.svg";